import { KeyingConfig, UpdateResolver } from "@urql/exchange-graphcache";
import { AddFaqMutationVariables, DeleteFaqMutationVariables, GetAnswersDocument, UpdateFaqItemMutationVariables } from "generated/graphql";
import { AnswerDocument } from "models";
import insertSorted from "utils/insertSorted";

function updateFaq(cached: AnswerDocument, vars: UpdateFaqItemMutationVariables) {
    cached.answer = vars.faq.answer;
    cached.questions = vars.faq.questions;
    cached.url = vars.faq.url;
}

export const faqKeys: KeyingConfig = {
    WebFAQ: (data: any) => data._id
};

export const faqUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    app: (result: any, args, cache, info) => {
        // Get the result, which has the _id
        const addFaqs = result.app?.update?.faq?.addFAQs;
        if (addFaqs) {
            const vars = info.variables as AddFaqMutationVariables;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetAnswersDocument,
                variables: { appId, size: 10, from: 0 }
            }, data => {
                if (!data) {
                    return data;
                }
                if (typeof data.app === "object" && !Array.isArray(data.app)) {
                    if (
                        typeof data.app.faq === "object" &&
                        !Array.isArray(data?.app?.faq)
                    ) {
                        const array = data?.app?.faq?.faq as AnswerDocument[] || [];

                        if (Array.isArray(vars.faqs)) {
                            vars.faqs.forEach((faq, index) => {
                                const resultFaq = addFaqs[index];
                                insertSorted(array, {
                                    __typename: "WebFAQ",
                                    // The faq is the answer, questions, url
                                    ...faq,
                                    // The resultFaq is the _id, information from the create response
                                    ...resultFaq
                                } as any, (left, right) => {
                                    return left.name.localeCompare(right.name);
                                });
                            });
                        }
                    }
                }

                return data;
            });
        }

        if (result.app?.update?.faq?.update?.updateFAQ) {

            const vars = info.variables as UpdateFaqItemMutationVariables;
            const id = vars.faqId;
            const appId = vars.appId;

            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetAnswersDocument,
                variables: { appId }
            }, data => {
                if (!data) {
                    return data;
                }
                if (typeof data.app === "object" && !Array.isArray(data.app)) {
                    if (
                        typeof data?.app?.faq === "object" &&
                        !Array.isArray(data?.app?.faq)
                    ) {
                        const array = data?.app?.faq?.faq as AnswerDocument[] || [];
                        const cached = array.find(
                            (question) => question._id === id
                        );
                        if (cached) {
                            updateFaq(cached, vars);
                        }
                    }
                }

                return data;
            }
            );
        }

        if (result.app?.update?.faq?.update?.deleteFAQ) {
            const vars = info.variables as DeleteFaqMutationVariables;
            const id = vars.faqId;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetAnswersDocument,
                variables: { appId }
            }, data => {
                if (!data) {
                    return data;
                }
                if (typeof data.app === "object" && !Array.isArray(data.app)) {
                    if (
                        typeof data?.app?.faq === "object" &&
                        !Array.isArray(data?.app?.faq)
                    ) {
                        const array = data?.app?.faq?.faq as AnswerDocument[] || [];
                        const cachedIndex = array.findIndex(
                            (question) => question._id === id
                        );
                        array.splice(cachedIndex, 1);
                    }
                }

                return data;
            }
            );
        }
    }
};